import { CiapCidSelectModel } from 'components/form/field/select/CiapCidSelectField/CiapCidSelectField'
import { GrupoCondicaoSelectModel } from 'components/form/field/select/GrupoCondicaoSelectField'
import {
  AggregatorRelatorioGerencialEnum,
  OpcaoSelecionadaRelatorioGerencialEnum,
  PosicaoCampoRelatorioGerencialEnum,
  TipoAgrupamentoRelatorioGerencialEnum,
  TipoModuloEnum,
  UnidadePeriodoRelatorioGerencialEnum,
} from 'graphql/types.generated'

export interface ModeloPersonalizadoRelatorioGerencialFormModel {
  id?: string
  nome: string
  modulo: TipoModuloEnum
  unidadePeriodoModal?: UnidadePeriodoRelatorioGerencialEnum
  opcaoSelecionadaModal?: OpcaoSelecionadaRelatorioGerencialEnum
  ciapsCids: CiapCidSelectModel[]
  gruposCondicoes: ReadonlyArray<GrupoCondicaoSelectModel>
  campos: ModeloPersonalizadoRelatorioGerencialCampoModel[]
  aggregatorModal: AggregatorRelatorioGerencialEnum
  visibilidade: VisibilidadeModeloPersonalizadoEnum
  tipoAgrupamentoModal?: TipoAgrupamentoRelatorioGerencialEnum
}

export interface ModeloPersonalizadoRelatorioGerencialCampoModel {
  _id: ID
  isInconsistente?: boolean
  isAdicionadoAgora?: boolean
  isInvalido?: boolean
  items: ReadonlyArray<string>
  key: string
  posicao: PosicaoCampoRelatorioGerencialEnum
}

export enum VisibilidadeModeloPersonalizadoEnum {
  PUBLICO = 'PUBLICO',
  PRIVADO = 'PRIVADO',
}
